export default __webpack_public_path__ + "static/media/logo.f1671048.png";